import { SnackbarProgrammatic as Snackbar } from 'buefy'
import router from '@/router'
import API from '@/api'

const actions = {
  getFilials({ commit }) {
    API.fit.getFilials()
      .then(({ data: { data: { filials } } }) => {
        commit('setFilials', filials)
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось загрузить список департаментов.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
  },
  createRequest({ commit }, payload) {
    API.fit.createRequest(payload)
      .then(({ data: { data: { orderId } } }) => {
        router.push({
          name: 'Order',
          params: {
            orderId
          }
        })
      })
      .catch(() => {
        Snackbar.open({
          duration: 5000,
          message: '<span>Кажется что-то пошло не так</span>Не удалось создать FIT-запрос.',
          position: 'is-top-right',
          type: 'is-danger'
        })
      })
      .finally(() => {
        commit('setIsLoading', false)
      })
  }
}

export default actions